const WhyElPasoSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
              Why Choose <strong>Local El Paso Buyers</strong>?
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              When you're selling your home, you have options. You could list with a traditional real estate agent, try selling it yourself, or work with a cash buyer. But not all cash buyers are created equal. Here's why working with a local El Paso home buying company makes all the difference.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-home-heart-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2 text-gray-900">We're Part of Your Community</h3>
                  <p className="text-gray-700">
                    We're not a faceless corporation or out-of-state investor. We live in El Paso, our kids go to local schools, and we shop at the same stores you do. Your success is our community's success.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-speed-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2 text-gray-900">Lightning-Fast Decisions</h3>
                  <p className="text-gray-700">
                    Because we're local, we can view your property quickly and make offers within 24 hours. No waiting for corporate approval or out-of-state decision makers.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-shield-check-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2 text-gray-900">Proven Track Record</h3>
                  <p className="text-gray-700">
                    With over 1,200 successful transactions in El Paso, we have the experience and reputation you can trust. Check our reviews from your neighbors.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-hand-heart-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2 text-gray-900">Personalized Service</h3>
                  <p className="text-gray-700">
                    You'll work directly with our team, not a call center. We take time to understand your situation and provide solutions tailored to your needs.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/7fe8a81be056770b6cbe9ba2c7f06981.jpg"
              alt="Happy El Paso homeowner"
              className="w-full h-full rounded-xl shadow-2xl object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyElPasoSection;
